export default "__VITE_ASSET__BjSdg6pH__"